import React from "react";

export default function WeekDayButton(props) {
  return (
    <button
      className="px-4 py-2 rounded-full bg-[var(--brand)] text-white text-sm md:text-base font-semibold"
    >
      {props.name}
    </button>
  );
}
